if (!customElements.get('faq-accordion')) {
  customElements.define(
    'faq-accordion',
    class FaqAccordion extends HTMLElement {
      constructor() {
        super();
        this.handleClick = this.handleClick.bind(this);
        this.handleMediaChange = this.handleMediaChange.bind(this);
      }

      connectedCallback() {
        const desktopBreakpoint = Number(this.dataset.desktopBreakpoint) || 1024;
        this.desktopMq = window.matchMedia(`(min-width: ${desktopBreakpoint}px)`);

        this.addEventListener('click', this.handleClick);

        if (typeof this.desktopMq.addEventListener === 'function') {
          this.desktopMq.addEventListener('change', this.handleMediaChange);
        } else if (typeof this.desktopMq.addListener === 'function') {
          // Legacy Safari
          this.desktopMq.addListener(this.handleMediaChange);
        }

        this.applyViewportDefaults();
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);

        if (typeof this.desktopMq?.removeEventListener === 'function') {
          this.desktopMq.removeEventListener('change', this.handleMediaChange);
        } else if (typeof this.desktopMq?.removeListener === 'function') {
          // Legacy Safari
          this.desktopMq.removeListener(this.handleMediaChange);
        }
      }

      handleMediaChange() {
        this.applyViewportDefaults();
      }

      handleClick(event) {
        const button = event.target.closest('.exclusie-faq-question');
        if (!button || !this.contains(button)) return;

        event.preventDefault();

        const answer = this.getAnswerEl(button);
        if (!answer) return;

        button.dataset.userToggled = 'true';
        answer.dataset.userToggled = 'true';

        const willOpen = !answer.classList.contains('open');
        this.setOpenState(button, answer, willOpen);
      }

      applyViewportDefaults() {
        const isDesktop = Boolean(this.desktopMq?.matches);

        const items = this.querySelectorAll('.exclusie-faq-item');
        items.forEach((item) => {
          const button = item.querySelector('.exclusie-faq-question');
          const answer = item.querySelector('.exclusie-faq-answer');
          if (!button || !answer) return;

          // Respect the user's choice after interaction.
          if (button.dataset.userToggled === 'true' || answer.dataset.userToggled === 'true') return;

          const openDesktop = button.dataset.openDesktop === 'true';
          const openMobile = button.dataset.openMobile === 'true';
          const shouldOpen = isDesktop ? openDesktop : openMobile;

          this.setOpenState(button, answer, shouldOpen);
        });
      }

      getAnswerEl(button) {
        const controlsId = button.getAttribute('aria-controls');
        if (controlsId) {
          // eslint-disable-next-line compat/compat
          return this.querySelector(`#${CSS.escape(controlsId)}`);
        }

        const nextEl = button.nextElementSibling;
        if (nextEl?.classList?.contains('exclusie-faq-answer')) return nextEl;
        return null;
      }

      setOpenState(button, answer, open) {
        button.classList.toggle('open', open);
        answer.classList.toggle('open', open);
        button.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
    }
  );
}


if (!customElements.get('faq-section')) {
  customElements.define(
    'faq-section',
    class FaqSection extends HTMLElement {
      constructor() {
        super();
        this.handleClick = this.handleClick.bind(this);
      }

      connectedCallback() {
        if (this.dataset.enableSmoothScroll !== 'true') return;
        this.addEventListener('click', this.handleClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
      }

      handleClick(event) {
        const link = event.target.closest('a[data-faq-smooth-scroll="true"]');
        if (!link || !this.contains(link)) return;

        const href = link.getAttribute('href');
        if (!href) return;

        let url;
        try {
          url = new URL(href, window.location.href);
        } catch (e) {
          return;
        }

        if (!url.hash || url.hash.length < 2) return;

        const current = new URL(window.location.href);
        const isSamePage = url.origin === current.origin && url.pathname === current.pathname && url.search === current.search;
        if (!isSamePage) return;

        let targetId;
        try {
          targetId = decodeURIComponent(url.hash.slice(1));
        } catch (e) {
          targetId = url.hash.slice(1);
        }

        // eslint-disable-next-line compat/compat
        const target = document.getElementById(targetId) || document.querySelector(`#${CSS.escape(targetId)}`);
        if (!target) return;

        event.preventDefault();

        const prefersReducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches;
        const behavior = prefersReducedMotion ? 'auto' : 'smooth';

        const bodyPaddingTop = Number.parseFloat(window.getComputedStyle(document.body).paddingTop) || 0;
        const stickyHeader = document.querySelector('.header-sticky');
        const stickyHeaderHeight = stickyHeader?.getBoundingClientRect?.().height || 0;
        const offset = Math.max(bodyPaddingTop, stickyHeaderHeight);

        const targetTop = target.getBoundingClientRect().top + window.scrollY;
        const top = Math.max(0, targetTop - offset);

        window.scrollTo({ top, behavior });
      }
    }
  );
}

